import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProductDTO, ProductListDTO } from '../models/product.model';
import { LinqPredicateDTO } from '../models/linqPredicate.model';
import { FilterService } from './filter.service';

@Injectable({
  providedIn: 'root'
})

export class ProductService {

  constructor(private http: HttpClient, private filterService: FilterService) {
  }

  getAllProducts(linqPredicate: Array<LinqPredicateDTO> = null): Promise<Array<ProductListDTO>> {

    if (linqPredicate == null || linqPredicate == undefined)
      linqPredicate = new Array<LinqPredicateDTO>();

    let fk_companyPredicate: Array<LinqPredicateDTO> = this.filterService.getCompanyHierarchyFilter("FK_Company");

    //Lo accoda agli eventuali filtri che arrivano come parametri
    let linqPredicates: Array<LinqPredicateDTO> = fk_companyPredicate.concat(linqPredicate);

    return this.http.post<Array<ProductListDTO>>(environment.apiFullUrl + '/Product/GetAll', linqPredicates).toPromise();
  }

  getProductByID(id: number): Promise<ProductDTO> {
    return this.http.get<ProductDTO>(environment.apiFullUrl + '/Product/' + id).toPromise();
  }

  saveProduct(product: ProductDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/Product', product).toPromise()
  }

  deleteProduct(id: number): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + '/Product/' + id).toPromise();
  }

  setDisableStatus(id: number, disableStatus: boolean): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Product/' + id + '/disablestatus/' + disableStatus).toPromise();
  }
}
